import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import { Formik, Form } from "formik";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
} from "../../../../_metronic/_partials/controls";
import * as Yup from "yup";
import {
  createCategoryAsync,
  updateCategoryAsync,
  getCategoryDetailAsync,
} from "../redux/categoryApi";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

export function HdpAddCategory() {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { selectedCategory } = useSelector(
    (state) => state.hdp_category || {},
    shallowEqual
  );
  const id = params.id;

  useEffect(() => {
    if (id) {
      dispatch(getCategoryDetailAsync(id));
    }
  }, [id, dispatch]);

  const initialValues = {
    slug: "",
    title: "",
    display_num: "",
  };

  const redirectBack = () => {
    history.push("/hdp_category");
  };

  const addSchema = Yup.object().shape({
    slug: Yup.string().trim().required("Please enter slug"),
    title: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Please enter Category Title"
      )
      .required("Please enter Category title"),
    display_num: Yup.string()
      .trim()
      .required("Please enter Category Display Number"),
  });

  const convertToSlug = (str) => {
    return str
      .toLowerCase()
      .trim()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/-+/g, "-");
  };

  return (
    <Formik
      enableReinitialize
      initialValues={
        selectedCategory && params?.id !== undefined
          ? selectedCategory
          : initialValues
      }
      validationSchema={addSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        let data = {
          slug: values.slug,
          title: values.title,
          display_num: values.display_num,
        };
        setSubmitting(true);
        if (params?.id !== undefined) {
          dispatch(
            updateCategoryAsync(data, setSubmitting, resetForm, redirectBack)
          );
        } else {
          dispatch(
            createCategoryAsync(data, setSubmitting, resetForm, redirectBack)
          );
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <Card>
          <CardHeader
            title={
              <div className="form-group m-0 d-flex align-items-center">
                <Link className="btn btn-link px-0" to="/hdp_category">
                  <SVG
                    className="h-50 align-self-center"
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Navigation/Arrow-left.svg"
                    )}
                  />
                  Back
                </Link>
                <span className="pl-2">
                  {params?.id ? "Edit HDP Category" : "Add HDP Category"}
                </span>
              </div>
            }
          ></CardHeader>
          <CardBody>
            <Row className="justify-content-center">
              <Col lg={8}>
                <Form>
                  <div className="form-group">
                    <label className="form-label">Category Title</label>
                    <input
                      placeholder="Enter Category Title"
                      type="text"
                      name="title"
                      className={
                        errors.title && touched.title
                          ? "form-control re_inputRouded is-invalid"
                          : "form-control re_inputRouded"
                      }
                      onChange={(e) => {
                        handleChange(e);
                        if (!params?.id) {
                          setFieldValue("slug", convertToSlug(e.target.value));
                        }
                      }}
                      onBlur={handleBlur}
                      value={values.title ? values.title : ""}
                    />
                    {touched.title && errors.title ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">{errors.title}</div>
                      </div>
                    ) : null}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Slug</label>
                    <input
                      placeholder="Enter Slug"
                      type="text"
                      name="slug"
                      className={
                        errors.slug && touched.slug
                          ? "form-control re_inputRouded is-invalid"
                          : "form-control re_inputRouded"
                      }
                      onChange={handleChange}
                      onBlur={(event) => {
                        let slug = event.target.value;
                        if (slug) {
                          slug = convertToSlug(slug);
                        }
                        setFieldValue("slug", slug);
                      }}
                      value={values.slug ? values.slug : ""}
                    />
                    {touched.slug && errors.slug ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">{errors.slug}</div>
                      </div>
                    ) : null}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Display Number</label>
                    <input
                      placeholder="Enter Display Number"
                      type="number"
                      name="display_num"
                      className={
                        errors.display_num && touched.display_num
                          ? "form-control re_inputRouded is-invalid"
                          : "form-control re_inputRouded"
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.display_num !== undefined ? values.display_num : ""}
                    />
                    {touched.display_num && errors.display_num ? (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">{errors.display_num}</div>
                      </div>
                    ) : null}
                  </div>

                  <div className="text-center mt-5">
                    <button
                      type="submit"
                      className="btn btn-primary font-weight-bold px-9 py-4"
                      disabled={isSubmitting}
                    >
                      {params?.id ? "Update Category" : "Save Category"}
                    </button>
                  </div>
                </Form>
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </Formik>
  );
}
